import { render } from "./multipleChoices.vue?vue&type=template&id=4e85d79e&scoped=true"
import script from "./multipleChoices.vue?vue&type=script&lang=js"
export * from "./multipleChoices.vue?vue&type=script&lang=js"

import "./multipleChoices.vue?vue&type=style&index=0&id=4e85d79e&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e85d79e"]])

export default __exports__